import controller from './quotations.controller';
import template from './quotations.view.html';

let QuotationsComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default QuotationsComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/payments-advances/quotations/quotations.component.js
 **/